import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { PageHead, Section, Spinner, ErrorNote, Empty, useAsync } from '../components/ui';
import { EventCard } from '../components/cards';
import { unenrolledFirst } from '../lib/sort';
import { useRole } from '../app/RoleContext';
import { fromHere } from '../components/BackCrumb';

export default function EventsPage() {
  const navigate = useNavigate();
  const { canCreateEvents } = useRole();
  const [creating, setCreating] = useState(false);
  const { loading, error, data, reload } = useAsync(
    () => api.browseEvents().then((p) => (Array.isArray(p) ? p : [])),
    []
  );

  // Same draft-then-open flow as Courses so AssociationTabs is available
  // on the editor screen right away.
  const newEvent = async () => {
    setCreating(true);
    try {
      const created = await api.createEvent({
        requestName: 'Untitled event', state: 'STARTED', priceCents: 0, isPrivate: false,
        draft: true, // hidden from others until the first Save
      });
      navigate(`/leader/event/${created.id}?created=1`, fromHere('/events', 'Events'));
    } catch (e) { alert(e.message); setCreating(false); }
  };

  return (
    <div className="page">
      <PageHead
        icon="📅"
        title="Events"
        sub="Browse and register to join events"
        actions={canCreateEvents
          ? <button className="btn btn-primary" disabled={creating} onClick={newEvent}>{creating ? 'Creating…' : '+ New event'}</button>
          : null}
      />
      {loading ? <Spinner /> : error ? <ErrorNote error={error} onRetry={reload} /> : (
        <Section>
          {data.length === 0 ? <Empty>No events yet.</Empty> : (
            <div className="card-grid">
              {unenrolledFirst(data, 'joined').map((p) => <EventCard key={p.id} event={p} />)}
            </div>
          )}
        </Section>
      )}
    </div>
  );
}
